'use client';

import { Search, CalendarCheck, HeartHandshake, Sparkles } from 'lucide-react';

const steps = [
  {
    number: '01',
    title: 'Escolha seu profissional',
    description: 'Busque por especialidade médica, sintomas, avaliações de outros pacientes ou atendimento imediato.',
    icon: Search,
  },
  {
    number: '02',
    title: 'Agende em poucos cliques',
    description: 'Selecione a data ou o melhor horário e realize o pagamento seguro via PIX ou cartão de crédito.',
    icon: CalendarCheck,
  },
  {
    number: '03',
    title: 'Receba seu cuidado',
    description: 'Acesse a sala de teleconsulta com vídeo em alta definição ou receba o médico na sua casa.',
    icon: HeartHandshake,
  },
];

export function HowItWorks() {
  return (
    <section id="como-funciona" className="py-16 md:py-24 bg-card border-b border-border transition-colors">
      <div className="container-landing">
        <div className="mb-12 md:mb-16 text-left max-w-2xl">
          <div className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary uppercase tracking-widest mb-2">
            <Sparkles className="w-3.5 h-3.5" />
            <span>Sem complicação</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-foreground tracking-tight">
            Cuidar da saúde ficou simples
          </h2>
          <p className="text-muted-foreground text-sm sm:text-base mt-2 leading-relaxed">
            Do agendamento à emissão da receita médica com assinatura digital em 3 passos transparentes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {steps.map((step) => {
            const Icon = step.icon;
            return (
              <div
                key={step.number}
                className="relative p-6 sm:p-8 rounded-3xl bg-muted/40 dark:bg-muted/20 border border-border/80 dark:border-white/[0.08] hover:border-primary/40 dark:hover:border-primary/50 hover:shadow-lg dark:hover:shadow-[0_10px_30px_rgba(0,0,0,0.5)] transition-all duration-200 text-center flex flex-col items-center justify-between"
              >
                {/* Background Giant Step Number */}
                <span className="text-5xl sm:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-b from-primary/35 to-primary/10 select-none font-mono mb-2">
                  {step.number}
                </span>

                <div className="w-14 h-14 rounded-2xl bg-primary/10 dark:bg-primary/15 text-primary border border-primary/20 flex items-center justify-center mb-4 shadow-xs">
                  <Icon className="w-7 h-7" />
                </div>

                <h3 className="text-lg font-bold text-foreground mb-2">
                  {step.title}
                </h3>

                <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
